interface LicensePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function LicensePagination({
  currentPage,
  totalPages,
  onPageChange,
}: LicensePaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const maxVisible = 5;
  let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  const end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start + 1 < maxVisible) {
    start = Math.max(1, end - maxVisible + 1);
  }
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-6">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="p-2 rounded-lg border border-gray-200 dark:border-dark-border disabled:opacity-40 hover:bg-gray-100 dark:hover:bg-dark-card transition-all"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`w-9 h-9 rounded-lg text-sm font-medium transition-all ${
            page === currentPage
              ? "bg-primary-500 text-gray-900 shadow"
              : "border border-gray-200 dark:border-dark-border hover:bg-gray-100 dark:hover:bg-dark-card text-gray-600 dark:text-gray-400"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="p-2 rounded-lg border border-gray-200 dark:border-dark-border disabled:opacity-40 hover:bg-gray-100 dark:hover:bg-dark-card transition-all"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}
